import { render, staticRenderFns } from "./BannerItem.vue?vue&type=template&id=0ed20f5c&scoped=true&"
import script from "./BannerItem.vue?vue&type=script&lang=js&"
export * from "./BannerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed20f5c",
  null
  
)

export default component.exports